exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{@page{size:210mm 297mm landscape}.application,.container .v-card,.v-flex,.v-layout,body{background-color:transparent!important}.v-navigation-drawer,footer.v-footer{display:none}.theme--light.v-toolbar,.v-toolbar{display:block!important}main.v-content{padding:20px!important}.report-container{width:100%!important;margin:0!important;padding:0!important}.elevation-2,.v-card{-webkit-box-shadow:none!important;box-shadow:none!important}.question-card{page-break-before:always!important}.no-break{page-break-inside:avoid!important}.no-print{display:none!important}table.v-table tbody td,table.v-table tbody th{height:30px}}a.v-tabs__item:hover{text-decoration:none!important;font-weight:bolder}.v-chip{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6aac69aa","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/assembly/virtualreport-print.vue
// module id = /83J
// module chunks = 2